<section class="search-result-container">
  <!-- RESULTS -->
  <section
    class="search-result-wrapper"
    *ngIf="searchViewModel?.searchResponse?.totalNumberOfRecords; else notFound"
  >
    <h2
      *ngIf="mode === pageModes.replacementSearch"
      data-cy="search-result-page-mode-text"
    >
      {{ 'i18n.search.searchResults.suggested' | translate }}
      {{
        replacementBaseProduct?.alternative.type === alternativeTypes.substitute
          ? ('i18n.search.searchResults.substitutes' | translate)
          : ('i18n.search.searchResults.replacements' | translate)
      }}
    </h2>
    <h2
      *ngIf="
        mode === pageModes.exceptionSearch ||
        mode === pageModes.cartReplacementSearch
      "
      data-cy="search-result-page-mode-text"
    >
      {{ 'i18n.search.searchResults.suggestedSubstitute' | translate }}
    </h2>
    <cdk-virtual-scroll-viewport
      class="cdk-scroll"
      orientation="vertical"
      appCustomVs
      [itemHeights]="itemHeights"
      [items]="searchViewModel?.listProducts"
      [indexOffset]="1"
      (scrolledIndexChange)="nextBatch($event)"
      [measureViewportSize]="false"
    >
      <app-selectable-search-result
        *cdkVirtualFor="
          let product of searchViewModel?.listProducts;
          let i = index;
          trackBy: trackProduct
        "
        [class.selectable]="itemsSelectable"
        [mode]="mode"
        [pwrRatingStarsMap]="pwrRatingStarsMap"
        [product]="product"
        [replacementProduct]="replacementBaseProduct"
        [isHideQuantity]="modeConfig.hideQuantity"
        [isTouchExperience]="isTouchExperience"
        [pageType]="searchViewModel?.searchRequest?.pageType"
        [totalNumberOfRecords]="
          searchViewModel?.searchResponse?.totalNumberOfRecords
        "
        [selectable]="itemsSelectable"
        [index]="i"
        (selectionChange)="updateSelection(product)"
      ></app-selectable-search-result>
    </cdk-virtual-scroll-viewport>
  </section>
  <!--    NO RESULTS-->
  <ng-template #notFound>
    <app-search-result-not-found
      *ngIf="!!searchViewModel && !searchViewModel.isLoadingMore"
      [isGuestUser]="isGuestUser"
      [coveoTopSellers]="coveoTopSellers"
      [search]="
        searchViewModel?.searchRequest?.searchText === undefined
          ? headerText
          : searchViewModel?.searchRequest?.searchText
      "
    >
    </app-search-result-not-found>
  </ng-template>
</section>
